import styled from '@emotion/styled';

export const BadgesContainer = styled.div`
  margin-bottom: 1em;
  margin-top: 0.5em;

  @media (max-width: 768px) {
    margin-top: 0em;
  }
`;

export const FeatureList = styled.div`
  display: flex;
  width: 50%;

  @media (max-width: 768px) {
    margin-left: 82px; // 72px is the width of the logo + 10px margin
  }
`;

export const BadgeButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 24px;

  &:not(:first-child) {
    margin-left: 1em;
  }

  @media (max-width: 768px) {
    width: 26px;
    height: 20px;

    &:not(:first-child) {
      margin-left: 0.75em;
    }
  }
`;

export const BadgeIcon = styled.img`
  width: 20px;
  height: 20px;

  @media (max-width: 768px) {
    width: 16px;
    height: 16px;
  }
`;
